import logo from "@/assets/datacom-logo.svg";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  showWordmark?: boolean;
  size?: "sm" | "md" | "lg" | "xl";
}

const SIZES = {
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-12 w-12",
  xl: "h-20 w-20",
};

export function Logo({ className, showWordmark, size = "md" }: LogoProps) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <img
        src={logo}
        alt="Datacom"
        className={cn(SIZES[size], "shrink-0 select-none")}
        draggable={false}
      />
      {showWordmark && (
        <div className="flex flex-col leading-tight">
          <span className="whitespace-nowrap text-base font-semibold tracking-tight text-foreground">
            Datacom AI
          </span>
          {/* whitespace-nowrap: andando a capo diventava «Supporto / tecnico» su
              due righe, e schiacciava quello che gli sta accanto. */}
          <span className="whitespace-nowrap text-xs text-muted-foreground">
            Supporto tecnico
          </span>
        </div>
      )}
    </div>
  );
}